import { mainSiteUrl } from '@/mocks/navigation';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20dreamy%20abstract%20background%20with%20flowing%20warm%20cream%20and%20sandy%20beige%20organic%20shapes%2C%20delicate%20translucent%20layers%20creating%20gentle%20depth%2C%20minimalist%20modern%20aesthetic%2C%20subtle%20warm%20golden%20undertones%2C%20elegant%20smooth%20gradient%20textures%2C%20no%20sharp%20edges%20or%20text%2C%20high%20quality%20artistic%20wallpaper%20style%2C%20ethereal%20light%20atmosphere&width=1800&height=1000&seq=hero-bg-vigorbuy-v2&orientation=landscape"
          alt="VigorBuy Spreadsheet background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/60 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-xs font-medium text-foreground-700 tracking-wide">
              THE COMPLETE RESOURCE HUB
            </span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-5">
            VigorBuy Spreadsheet:
            <br />
            <span className="text-accent-300">The Complete Guide,</span>
            <span> Reviews &amp; Resources</span>
          </h1>

          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover how VigorBuy Spreadsheet helps users organize data, improve productivity
            and manage information with powerful spreadsheet solutions designed for modern workflows.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
            >
              Explore Complete Guide
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold rounded-full bg-background-50/90 text-foreground-900 hover:bg-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Visit VigorBuy Spreadsheet
              <i className="ri-external-link-line ml-2"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
            {[
              'Complete Spreadsheet Tutorials',
              'Detailed Feature Reviews',
              'Security & Safety Information',
              'Expert Comparison Guides',
            ].map((badge) => (
              <div key={badge} className="flex items-center gap-2 text-sm text-background-200">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500/30">
                  <i className="ri-check-line text-xs text-accent-200"></i>
                </div>
                <span className="whitespace-nowrap">{badge}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}